/**
 * MLB items API: get item by marketplace_listing_id for Update listing page.
 * Backend uses app MLB OAuth token; user must be authenticated.
 */
import axios from 'axios';
import { authHeaders } from './apiAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Get current item state from Mercado Livre (for display/edit on Update listing page).
 * @param {string} accessToken - User's JWT
 * @param {string} marketplaceListingId - MLB item id (e.g. MLB6345310192)
 * @returns {Promise<{ success: boolean, item?: object, error?: string }>}
 */
export const getMlbItem = async (accessToken, marketplaceListingId) => {
  if (!marketplaceListingId || String(marketplaceListingId).trim() === '') {
    throw new Error('marketplace_listing_id is required');
  }
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/mlb/items/${encodeURIComponent(String(marketplaceListingId).trim())}`,
      { headers: authHeaders(accessToken) }
    );
    return response.data;
  } catch (error) {
    const detail = error.response?.data?.detail;
    const message = typeof detail === 'string' ? detail : detail?.message || 'Failed to get MLB item';
    throw new Error(message);
  }
};
